import React, { useState } from 'react';
import { userAuth, userDb } from '../firebaseUsers';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, query, where, getDocs } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';

const SignUp = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [gender, setGender] = useState('');
  const [ageRange, setAgeRange] = useState('');
  const [birthday, setBirthday] = useState('');
  const [error, setError] = useState('');
  const [pdfDownload, setPdfDownload] = useState(false);
  const navigate = useNavigate();
  const [year, month, day] = birthday.split('-');

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !email || !password || !confirmPassword || !gender || !ageRange || !birthday) {
      setError('Please fill in all fields.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
if (password.length < 6) {
  setError('Password must be at least 6 characters long.');
  return;
}
    const trimmedUsername = username.trim();
    const trimmedEmail = email.trim().toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(trimmedEmail)) {
      setError('Please enter a valid email address.');
      return;
    }

    try {
      const usersRef = collection(userDb, 'users');
      const [usernameSnap, emailSnap] = await Promise.all([
        getDocs(query(usersRef, where('username', '==', trimmedUsername))),
        getDocs(query(usersRef, where('email', '==', trimmedEmail)))
      ]);

      if (!usernameSnap.empty) {
        setError('Username already exists.');
        return;
      }

      if (!emailSnap.empty) {
        setError('Email already registered.');
        return;
      }

      const userCredential = await createUserWithEmailAndPassword(userAuth, trimmedEmail, password);
      const uid = userCredential.user.uid;

      const userData = {
        uid,
        username: trimmedUsername,
        email: trimmedEmail,
        gender,
        
        ageRange,
       birthday: new Date(year, month - 1, day),
        createdAt: new Date(),
      };

      await addDoc(usersRef, userData);

      // if (pdfDownload) {
      //   const doc = new jsPDF();
      //   const img = new Image();
      //   img.src = `/images/assets/wawLogo.png`;

      //   await new Promise(resolve => {
      //     img.onload = resolve;
      //     img.onerror = resolve;
      //   });

      //   doc.addImage(img, 'PNG', 10, 10, 20, 20);
      //   doc.setFontSize(12);
      //   doc.text(`Username: ${trimmedUsername}`, 10, 40);
      //   doc.text(`Email: ${trimmedEmail}`, 10, 50);
      //   doc.text(`Gender: ${gender}`, 10, 60);
      //   doc.text(`Age Range: ${ageRange}`, 10, 70);
      //   doc.text(`Birthday: ${birthday}`, 10, 80);
      //   doc.text(`Thank you for registering with us!`, 10, 120);
      //   doc.text(`Wear & Wonder Boutique LLC`, 10, 130);
      //   doc.save(`${trimmedUsername}_signup.pdf`);
      // }
if (pdfDownload) {
  const doc = new jsPDF();
  const img = new Image();
  img.src = `https://res.cloudinary.com/dcuturlmb/image/upload/v1759925386/my_uploads/hxauczbx0yznuhyoumbz.png`;

  await new Promise(resolve => {
    img.onload = resolve;
    img.onerror = resolve;
  });

  doc.addImage(img, 'PNG', 10, 10, 30, 30);
  doc.setFontSize(16);
  // doc.text("Sign-Up Confirmation", 50, 20);

  autoTable(doc, {
    startY: 50,
    head: [['Field', 'Value']],
    body: [
      ['Username', trimmedUsername],
      ['Email', trimmedEmail],
      ['Gender', gender],
      ['Age Range', ageRange],
      ['Birthday', birthday],
    ],
    theme: 'striped',
    styles: { fontSize: 12, cellPadding: 4 },
    headStyles: { fillColor: [7, 29, 73] },
  });

  doc.setFontSize(12);
  doc.text("Thank you for registering with us!", 14, doc.lastAutoTable.finalY + 20);
  doc.text("Wear & Wonder Boutique LLC", 14, doc.lastAutoTable.finalY + 30);

  doc.save(`${trimmedUsername}_signup.pdf`);
}

      alert('Account created!');
      navigate('/');
    } catch (err) {
      
      if (err.code === 'auth/email-already-in-use') {
        setError('Email is already in use.');
      } else {
        console.error(err);
        setError(`Signup failed. Please try again.`);
      }
    }
  };

  return (
    <>
      <style>{`
        @keyframes spinX {
          0% { transform: rotateY(0deg); }
          100% { transform: rotateY(360deg); }
        }

        @keyframes colorChange {
          0% { color: #555; }
          50% { color: #0e3b74; }
          100% { color: #555; }
        }

        .spinning-label {
          display: block;
          animation: spinX 8s linear infinite, colorChange 8s ease-in-out infinite;
          transform-origin: center;
          font-weight: 600;
          margin: 0 auto 8px auto;
          width: max-content;
          text-align: center;
          cursor: default;
        }
      `}</style>

      <div style={styles.container}>
        <h2 style={styles.title}>Create Account</h2>
        <form onSubmit={handleSignUp}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={styles.input}
          />

          <select style={styles.input} value={gender} onChange={(e) => setGender(e.target.value)}>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Non-binary">Non-binary</option>
            <option value="Prefer not to say">Prefer not to say</option>
          </select>

          <select style={styles.input} value={ageRange} onChange={(e) => setAgeRange(e.target.value)}>
            <option value="">Select Age Range</option>
            <option value="Under 18">Under 18</option>
            <option value="18-24">18-24</option>
            <option value="25-34">25-34</option>
            <option value="35-44">35-44</option>
            <option value="45-54">45-54</option>
            <option value="55-64">55-64</option>
            <option value="65+">65+</option>
          </select>

          <label className="spinning-label">Date of birth</label>
          <input
            type="date"
            value={birthday}
            onChange={(e) => setBirthday(e.target.value)}
            style={styles.input}
          />

          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              checked={pdfDownload}
              onChange={() => setPdfDownload(!pdfDownload)}
            />
            &nbsp;Save sign-up confirmation as PDF
          </label>

          <button type="submit" style={styles.button}>
            Sign Up
          </button>

          {error && <p style={styles.error}>{error}</p>}
        </form>
      </div>
    </>
  );
};

const styles = {
  container: {
    maxWidth: 320,
    margin: '40px auto',
    padding: 20,
    border: '1px solid #ccc',
    borderRadius: 12,
    backgroundColor: '#fafafa',
    boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
  },
  title: {
    textAlign: 'center',
    marginBottom: 20,
  },
  input: {
    width: '100%',
    padding: 10,
    marginBottom: 12,
    borderRadius: 6,
    border: '1px solid #ccc',
    color: "#707174ff",
  },
  checkboxLabel: {
    fontSize: 14,
    display: 'block',
    marginBottom: 12,
  },
  button: {
    width: '100%',
    padding: 10,
    backgroundColor: '#071d49',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  error: {
    marginTop: 10,
    color: 'red',
    textAlign: 'center',
  },
};

export default SignUp;
